export const WHOLE_FARM_DETAILED_TABLES = {
    directCarbonDioxideResults: {
        tableTitle: 'Direct Carbon Dioxide',
        columns: [
            {title:'', key:'itemTitle'},
            {title:'Diesel', key:'diesel'},
            {title:'Electricity', key:'electricity'},
            {title:'Other fuels', key:'otherFuels'},
            {title:'Renewable heat and electricity', key:'renewableheatAndElectricity'},
            {title:'Total direct carbon dioxide', key:'totalDirectCarbonDioxide'},
        ]
    },
    indirectCarbonDioxideResults: {
        tableTitle: 'Indirect Carbon Dioxide (Farm inputs)',
        columns: [
            {title:'', key:'itemTitle'},
            {title:'Fertiliser', key:'fertiliser'},
            {title:'Lime', key:'lime'},
            {title:'Pesticides', key:'pesticides'},
            {title:'Bedding', key:'bedding'},
            {title:'Feed', key:'feed'},
            {title:'Energy', key:'energy'},
            {title:'Plastic use / disposal', key:'plasticUseDisposal'},
            {title:'Carcass disposal', key:'carcassDisposal'},
            {title:'Transport', key:'transport'},
            {title:'Total indirect carbon dioxide (other)', key:'totalIndirectCarbonDioxide'}
        ]
    },
    methaneResults: {
        tableTitle: 'Methane',
        columns: [{title:'', key:'itemTitle'},
            {title:'Feed digestion (GWP100)', key:'feedDigestion'},
            {title:'Manure management (GWP100)', key:'manureManagement'},
            {title:'Total methane (GWP100)', key:'totalMethane'},
            {title:'Total methane (GWP*)', key:'gwpFromMethane'}
        ],
        hTooltips: { gwpFromMethane:{
                    marker:'†',
                    responsive:true,
                    text:`<em>GWP</em> is an alternative way of reporting methane emissions. Methane breaks
                    down much faster than other greenhouse gasses but has a large upfront 
                    warming impact. GWP* aims to capture this effect better than the standard 
                    GWP100 metric. When measuring using GWP*, increased methane emissions 
                    have a large impact, but steady or declining emissions have a much smaller 
                    impact.`,
                    displayCondition: (results)=>{return true}
                    }
                },
    },
    nitrousOxideResults: {
        tableTitle: 'Nitrous Oxide',
        columns: [
            {title:'', key:'itemTitle'},
            {title:'Imported fertilisers and manures', key:'importedFertilisersManures'},
            {title:'Grazing, manure spreading, and manure management', key:'grazingManureSpreadingManagement'},
            {title:'Crop residues', key:'cropResidues'},
            {title:'Total nitrous oxide', key:'totalNitousOxide'}
        ]
    },
    carbonSequestrationResults: {
        tableTitle: 'Carbon Stock Changes',
        tableTitleTooltip: 'Estimates of changes in carbon stocks have been made using Tier 1 models. This is recognised under the GHG protocol as a valid approach to estimate emissions from carbon stocks but can only be used as an indication of sequestration potential. Therefore, any sequestration shown in this table is not included in your total carbon footprint',
        tableTitleTTIcon: '\u2021',
        columns: [
            {title:' ', key:'itemTitle'},
            {title:'Soil Carbon Emissions', key:'scEmissions', dataToggle:'showSoilCarbon'},
            {title:'Soil Carbon Sequestrations', key:'scSequestrations', dataToggle:'showSoilCarbon'},
            {title:'Biochar', key:'biocharClaimable', dataToggle:'showBiochar'},
            {title:'Estimated Biochar Sequestration', key:'biocharPotential', dataToggle:'showEstimatedBiochar'},
            {title:'Hedges', key:'hedges'},
            {title:'Forestry', key:'forestry'}],
        columnFilter: (cols,results) =>{
            //if we have a show data toggle in the results than use it
            return cols.filter((c) => c.dataToggle?results[c.dataToggle]:true)
        },
        hStyles:{ 'itemTitle':{width:'30%'},
                  'biocharPotential':{fontStyle:'italic'}
                },
        hTooltips:{
            biocharPotential: {
                marker:'*',
                responsive:false,
                text:`The carbon associated with the biochar applied has already been claimed.
                      That means it cannot be included in your carbon footprint.
                      The values shown in this column are to provide an indication of how much 
                      sequestration may be occurring, despite its exclusion from your carbon footprint.`,
                displayCondition: (results)=>{
                    return results?.showEstimatedBiochar}
                    }
        },
        bStyles:{ 'hedges':{fontStyle:'italic'},
                 'biocharPotential':{fontStyle:'italic'}},
    },
    totalEmissionsResults: {
        tableTitle: 'Total Emissions',
        columns: [
            {title:'', key:'itemTitle'},
            {title:'Gross emissions from farming', key:'grossEmissioFromFarming'},
            {title: "Farm Area", key:'farmArea'}
        ]
    },
    productEmissionResults: {
        tableTitle: 'Product Emission Table',
        columns: [
            {title:'', key:'sector'},
            {title:'Enterprise', key:'enterprise'},
            {title:'Product (unit)', key:'productUnit'},
            {title:'Total output', key:'totalOutput'},
            {title:'Total emissions (kg CO₂-eq)', key:'totalEmissions'},
            {title:'Emissions per unit (kg CO₂-eq)', key:'emissionsPerUnit'}],
        noFooter: true,
    }
}

export const SUMMARY_TABLE = {
    emissionSummaryResults: {
        tableTitle: 'Emission Summary Table',
        columns: [
            {title:'', key:'itemTitle'},
            {title:'Direct CO₂', key:'directCo2'},
            {title:'Indirect CO₂', key:'indirectCo2'},
            {title:'Methane (CO₂-eq)', key:'methane'},
            {title:'Nitrous oxide (CO₂-eq)', key:'nitrousOxide'},
            {title:'Carbon stock emissions', key:'carbonStockChanges'},
            {title:'Gross Emissions (kg CO₂-eq)', key:'grossEmissions'}
        ]
    },
    productEmissionResults: {
        tableTitle: 'Product Emission Table',
        columns: [
            {title:'', key:'sector'},
            {title:'Enterprise', key:'enterprise'},
            {title:'Product (unit)', key:'productUnit'},
            {title:'Total output', key:'totalOutput'},
            {title:'Total emissions (kg CO₂-eq)', key:'totalEmissions'},
            {title:'Emissions per unit (kg CO₂-eq)', key:'emissionsPerUnit'}
        ],
        noFooter: true,
    }

}

const opportunityLevelDisplayZero = (row) => {
    // if one of the values isn't zero but the other is then show the zero
    return row.emission !== 0 || row.comparisonValue !== 0
}

export const ENTERPRISE_DETAILED_TABLES = [
    {
        tableTitle: 'Quick glance emissions',
        key: 'quickGlanceEmissions',
        noFooter: true,
        columns: [
            { title: "Enterprise Source", key: "title",},
            // { title: "Source Percentage", key: "sourcePercentage",},
            { title: "kg CO₂ -eq / kg product", key: "emission", isDynamic: true },
            { title: "Compared To", key: "comparisonValue",},
            { title: "Opportunity Level", key: "opportunityLevel", isOL:true},],
        olDisplayZero: opportunityLevelDisplayZero,
        hTooltips:{
            opportunityLevel:{
                marker: '\u2051',
                responsive: true,
                text:`Indicates the potential for improvement relative to the enterprise compared to. \
                     <br/><br/>'Low' - your emissions are lower than 25% below the average \
                     <br/>'Medium' - your emissions are between -25% and + 25% of the average \
                     <br/>'High' - your emissions are over 25% of the average`,
                     displayCondition: (results)=>{return true}
            }
        },
        tableTooltips:[
            '** Other includes crop residues, lime, transport and waste.',
            `*** Total emission may differ due to rounding. Emissions may be skewed on a year to year 
                basis due to timing of sales therefore results are best monitored over a three year (minimum) period.`
        ],

    },
    {
        tableTitle: 'Physical performance',
        key: 'physicalPerformance',
        columns: [
            {title: "Performance Indicator", key: "title",},
            {title: "Value", key: "value",},
            {title: "Compared To", key: "comparisonValue",},
        ],
        noFooter: true,
    }
]

export const FARMER_FRIENDLY_TABLES = [
    {
        tableTitle: 'Physical performance',
        key: 'physicalPerformance',
        noFooter: true,
        columns: [
            {title: "Performance Indicator", key: "title",},
            {title: "Value", key: "value",},
            {title: "Compared To", key: "comparisonValue",},
        ],
    },
    {
        tableTitle: 'Enterprise Emissions Summary',
        tableTooltips: [
            '** Other includes crop residues, lime, transport and waste.',
            `*** Total emission may differ due to rounding. Emissions may be skewed on a year to year 
              basis due to timing of sales therefore results are best monitored over a three year (minimum) period.`,
        ],
        key: 'quickGlanceEmissions',
        columns: [
            { title: "Source", key: "title" },
            { title: "Your emissions (kg CO₂ -eq / kg dwt)", key: "emission",},
            { title: "Opportunity for improvement", key: "opportunityLevel", isOL:true},
            { title: "Comparison", key: "comparisonValue",},
        ],
        olDisplayZero: opportunityLevelDisplayZero,
        noFooter: true,
    },

]